import { render, staticRenderFns } from "./RoomFile.vue?vue&type=template&id=bccd13e0&"
import script from "./RoomFile.vue?vue&type=script&lang=js&"
export * from "./RoomFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports